import { useQuery } from '@tanstack/react-query';
import { getMedicalNoteDetailsById } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';


export const useMedicalNoteDetailsByIdQuery = (noteId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'medicalNote', noteId, 'details' ],
    queryFn: async () => {
      const response = await getMedicalNoteDetailsById(noteId);

      return response.data;
    },
    ...opts
  });
};
